// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"a98e5f09","341":"95cdcc3d","885":"b27acb31"}[chunkId] + ".chunk.js";
};